import { atom, selector } from "recoil"
import { TDevicePermissionStateKey, TDevicePermissionTypeKey } from "../../../components/settings/settings.interfaces"
import {
  AtomSettingsMuteType,
  AtomSettingsDevicesType,
  MobileCameraProps
} from "./types"

export const settingsDevicesAtom = atom<AtomSettingsDevicesType>({
  key: "settingsDevicesAtom",
  default: { video: null, audio: null }
})

export const mobileCamerasAtom = atom<MobileCameraProps>({
  key: "mobileCamerasAtom",
  default: {
    front: { id: "", label: "" },
    back: { id: "", label: "" }
  }
})

export const settingsMuteAtom = atom<AtomSettingsMuteType>({
  key: "settingsMuteAtom",
  default: { audio: false, video: false }
})

export const settingsTrackStatusAtom = atom({
  key: "settingsTrackStatusAtom",
  default: false
})

export const settingsDevicesSelector = selector<AtomSettingsDevicesType>({
  key: "settingsDevicesSelector",
  get: ({ get }) => get(settingsDevicesAtom),
  set: ({ set, get }, newDevices) =>
    set(settingsDevicesAtom, { ...get(settingsDevicesAtom), ...newDevices })
})

export const settingsMuteSelector = selector<AtomSettingsMuteType>({
  key: "settingsMuteSelector",
  get: ({ get }) => get(settingsMuteAtom),
  set: ({ set, get }, newActions) =>
    set(settingsMuteAtom, {
      ...get(settingsMuteAtom),
      ...newActions
    })
})

/* export const settingsTrackStatusSelector = selector<AtomSettingsTrackStatusType>({
  key: "settingsTrackStatusSelector",
  get: ({ get }) => get(settingsTrackStatusAtom),
  set: ({ set, get }, trackStatus) =>
    set(settingsTrackStatusAtom, {
      ...get(settingsTrackStatusAtom),
      ...trackStatus
    })
}) */

export const settingsTrackStatusSelector = selector({
  key: "settingsTrackStatusSelector",
  get: ({ get }) => {
    return get(settingsTrackStatusAtom)
  },
  set: ({ set }, trackStatus) => {
    set(settingsTrackStatusAtom, trackStatus)
  }
})

export const microphonePermissionStateAtom = atom<TDevicePermissionStateKey>({
  key: "microphonePermissionStateAtom",
  default: null
})

export const cameraPermissionStateAtom = atom<TDevicePermissionStateKey>({
  key: "cameraPermissionStateAtom",
  default: null
})


type showDevicePermissionOverlayProps = {
  type: TDevicePermissionTypeKey
  state: TDevicePermissionStateKey
}

export const showDevicePermissionOverlayAtom = atom<showDevicePermissionOverlayProps>({
  key: "showDevicePermissionOverlayAtom",
  default: null
})